import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'emailValidator'
})
export class EmailValidatorPipe implements PipeTransform {

 transform(value: string | null): string {
    if (!value) {
      return ''; // No mostrar nada si el valor es nulo o vacío
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Expresión regular para validar el formato de correo
    return emailRegex.test(value) ? '' : 'Formato de correo no válido. Debe ser como "ejemplo@dominio.com"';
  }

}
